import modelBaseV2 from "../model-base-v2.model";

const IMEIBasedSuccessRateModel = {
  getCustomers: () => modelBaseV2.get("/api/intf-edi/customers"),

  search: (criteria = {}) => {
    return modelBaseV2.post("/api/intf-edi/report/imei-success-rate/list", {
      body: criteria,
    });
  },

  exportSummaryReportToExcel: (
    config = {
      ediClientCode: [],
      fromWeek: "",
      toWeek: "",
      filename: "",
    }
  ) => {
    const { filename, ...rest } = config;

    return modelBaseV2.postDownload(
      "/api/intf-edi/report/imei-success-rate/export-summary",
      {
        body: rest,
      },
      filename
    );
  },

  exportPartialDetailReportToExcel: (
    config = {
      ediClientCode: [],
      fromWeek: "",
      toWeek: "",
      status: "",
      salesDate: "",
      filename: "",
    }
  ) => {
    const { filename, ...rest } = config;

    return modelBaseV2.postDownload(
      "/api/intf-edi/report/imei-success-rate/export-raw",
      {
        body: rest,
      },
      filename
    );
  },
};

export default IMEIBasedSuccessRateModel;
